export function sessionIdentity(
  admin: {
    adminEmail: string;
    userId?: string | null;
    workspaceId?: string | null;
  } | null,
): string {
  return admin
    ? JSON.stringify([admin.userId ?? admin.adminEmail.toLowerCase(), admin.workspaceId ?? null])
    : 'anonymous';
}
